<template>
  <div class="selector">
    <div :class="['selector-about',select == 'selector-about' ? 'active' : 'unactive']" @click="handleTicketOrder">
      <img v-if="select == 'selector-about'" src="~@/assets/image/common/common_about.png" alt="">
      <img v-else src="~@/assets/image/common/common_about_reverse.png" alt="">
      <span>Ticket Booking</span>
    </div>
    <div :class="['selector-order',select == 'selector-order' ? 'active' : 'unactive']" @click="handleUser">
      <img v-if="select == 'selector-order'" src="~@/assets/image/common/common_my_reverse.png" alt="">
      <img v-else src="~@/assets/image/common/common_my.png" alt="">
      <span>My Order</span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "selector",
  props:['select'],
  methods: {
    handleTicketOrder(){
      const { indexAccessRecord } = this.$store.state;
      const { path } = this.$route;
      if(indexAccessRecord === path)return;
      this.$emit('handleTicketOrder')
      // this.$router.push(indexAccessRecord);
    },
    async handleUser(){
      // const userInfo = await this.$getGroupUserInfo();
      // if(!userInfo){
      //   this.$router.push('/user');
      // }else{
      //   this.$router.push('/userguide');
      // }
      console.log(this.userInfo)
      if(this.userInfo && this.userInfo.extField1){
        this.$router.push('/userEn');
      }else{
        this.$router.push('/userEn')
      };
    },
  },
    computed: {
    ...mapState(['userInfo'])
  },
};
</script>

<style scoped lang='less'>
.selector{
  margin: 0.13rem .266667rem;
  padding: .04rem;
  background: #C49048;
  border-radius: .506667rem;
  display: flex;
  align-items: center;
  .selector-about,
  .selector-order{
    flex: 1;
    font-size: .48rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: .92rem;
    img{
      width: .426667rem;
    }
    span{
      margin-left: .2rem;
    }
  }
  .active{
    background: #FFFFFF;
    border-radius: .506667rem;
    span{
      color: #9D6C29;
      font-weight: bold;
    }
  }
  .unactive{
    span{
      color: #FFFFFF;
    }
  }
}
</style>
